const nerdamer = require('nerdamer/all')
    // // import _ from 'lodash'
import Big from "big.js"
import { MPE, OIML, checkWeight } from "./report_utility"
import { tolerance, linearity_values, repeatability_default, row_status_tooltip, block_status_tooltip, division_ranges, comparison_values, linearity_values_multirange } from "./common"
import { uoms_conversion } from "./commonUtils"
import {linearity_item_new, linearity_zavorra_item} from "./itemBlockSchema"

export const BaseLayout = {
    props: {
        data: {
            type: Object,
            required: false,
            default: null
        },
        preview: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            tutorial_dialog: {
                dialog: false,
                message: this.data.block.conf.tutorial_text
            },
            measures: null,
            instrument_data: null,
            precision: 0,
            conf: null,
            formulas: {},
            image_data: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
            row_tooltip: row_status_tooltip,
            block_tooltip: block_status_tooltip
        }
    },
    created() {
        this.debouncedSave = _.debounce(function() {
            // console.log('debouncedSave')
            if (!this.preview) {
                this.saveMeasures()
            }
        }, 1000)
    },
    methods: {
        async rebuildData(){
            this.buildMeasures()
        },
        saveMeasures() {
            this.calcBlockResult()
            this.$parent.$emit('updateMeasure', { b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id })
        },
        countDecimals(value) {
            if (value != null && value != undefined && value != "") {
                let bVal = Big(value)
                if (bVal.eq(bVal.toFixed(0))) {
                    return 0;
                }
                let split = value.toString().split(".")
                if (split.length > 1) {
                    return split[1].length
                }
            }
            return 0
        },
        calcMinRange(value) {
            if (value) {
                if(["bilancia nawi", "bilancia nawi meccanica"].includes(this.instrument_data.family)){
                    for(let i = 0; i< this.instrument_data.ranges.length; i++){
                        let range = this.instrument_data.ranges[i]
                        if(i < this.instrument_data.ranges.length -1){
                            if(Big(range.max).gte(value)){
                                return range
                            }
                        } else {
                            let div = this.instrument_data.instrument_class ? range.e : range.d
                            let bonus = Big(div).times(9)
                            if(Big(range.max).plus(bonus).gte(value)){
                                return range
                            } 
                        }
                    }
                } else {
                    for (let range of this.instrument_data.ranges) {
                        if (Big(range.max).gte(value)) {
                            return range
                        }
                    }
                }
            }
            return null
        },
        findMaxRange(platform = this.instrument_data) {
            return platform.ranges.reduce((acc, val) => {
                acc = (acc === undefined || Big(val.max).gt(acc.max)) ? val : acc
                return acc;
            }, { max: 0 })
        },
        findValues(weightTotal) {
            if (weightTotal && weightTotal != 0) {
                console.log("started change measures")
                let maxVal = this.findMaxRange().max
                let lastVal = Big(maxVal)
                let arr = []
                let k = 0;
                let val = Big(0)
                while (val.lte(lastVal.plus(lastVal.times(0.05)))) {
                    arr[k] = val.toString()
                    k = k + 1
                    val = Big(weightTotal).times(k)
                }
                let diff = this.data.block.conf.min_readings - arr.length
                console.log("$$ current diff", diff)
                let actualClass = this.calculateActualClass()
                if(diff == 0){
                    let firstpoint = this.calculateMass(linearity_values[0], actualClass)
                    arr.splice(1, 0, firstpoint)
                }
                for (let i = 0; i < diff; i++) {
                    let newMeasure = this.calculateMass(linearity_values[i], actualClass)
                    if (Big(weightTotal).gte(newMeasure)) {
                        arr.splice(i + 1, 0, newMeasure)
                    }
                }
                console.log("$$ final arr", arr)
                return arr
            }
            return null
        },
        buildMeasures() {
            console.log("this is the default behavior")
        },
        calcBlockResult() {
            let result = 'done'
            this.measures.result = this.measures.items.reduce(function(result, item) {
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, result)
            // console.log('******* this.measures.result', this.measures.result)
        },
        calc_MPE(currentRange, actualMass, mpeIntervals = [1, 2, 3]) {
            if (currentRange) {
                let div = this.instrument_data.instrument_class ? currentRange.e : currentRange.d
                return this.round(MPE(this.instrument_data.instrument_class, [div], currentRange.div_nr, actualMass, mpeIntervals))
            } else {
                return this.round("0")
            }
        },
        calc_OIML(currentRange, actualMass) {
            if (currentRange) {
                return this.round((OIML([currentRange.d], currentRange.div_nr, actualMass)))
            } else {
                return this.round("0")
            }
        },
        sheetColor(value) {
            if (value) {
                return "success"
            } else {
                return "error"
            }
        },
        round(value, decimals = this.currentPrecision) {
            let big = new Big(value)
            return big.toFixed(decimals)
        },
        handleCloseDialog() {
            this.tutorial_dialog.dialog = false;
        },
        openDialog(message) {
            this.tutorial_dialog.message = message;
            this.tutorial_dialog.dialog = true;
        },

        checkDivisions(value, tempDiv) {
            // *********** CHECK - VERIFICARE PERCHÈ tempdiv è undefined
            if (value != undefined && value != null && value != '' && tempDiv != undefined && tempDiv != null && tempDiv != '') {
                let big = new Big(value)
                let temp = big.mod(tempDiv).eq(0)
                return temp
            } else {
                return false
            }
        },
        checkPrecision(value, precision = null) {
            if (value != undefined && value != null && value != '' && value != "-") {
                if (precision == null) {
                    precision = (this.measures.hi_res && this.measures.hi_res == 'on') ? this.high_precision : this.precision
                }
                return this.countDecimals(value) <= precision
            } else {
                return false
            }
        },
        checkReading(value, range = null) {
            if (value != undefined && value != null && value != '' && value != "-") {
                if (!this.checkPrecision(value)) {
                    return 'failed'
                }
                let currRange = null
                if (range) {
                    currRange = range
                } else {
                    currRange = this.calcMinRange(value)
                }
                if (currRange) {
                    let min_div = this.calculateMinDiv(currRange)
                    if (this.checkDivisions(value, min_div)) {
                        return 'done'
                    } else {
                        return 'failed'
                    }
                } else {
                    return 'failed'
                }
            } else {
                return 'uncomplete'
            }
        },
        //TODO convertire anche questo
        calcDigits(type) {
            let min = 0
            if (type == "d") {
                min = this.instrument_data.ranges.reduce((acc, val) => {
                    acc = (acc === undefined || val.d < acc) ? val.d : acc
                    return acc;
                }, Number.POSITIVE_INFINITY)
            } else if (type == "e") {
                min = this.instrument_data.ranges.reduce((acc, val) => {
                    acc = (acc === undefined || val.e < acc) ? val.e : acc
                    return acc;
                }, Number.POSITIVE_INFINITY)
            }
            console.log("$$ minimum: ", type, min)
            return this.countDecimals(min)
        },
        async beforeMountBuilder() {
            if (this.data) {
                this.instrument_data = this.data.instrument_data
                this.conf = this.data.block.conf
                this.calculatePrecisions()
                if (this.data.block.measures) {
                    this.measures = this.data.block.measures;
                    await this.getImage()
                } else {
                    await this.buildMeasures();
                }
            }
        },

        calculatePrecisions() {
            if (this.data.block.op_types.includes("leg")) {
                if (this.has_hi_res) {
                    this.precision = this.calcDigits("e")
                    this.high_precision = this.calcDigits("d")
                } else {
                    this.precision = this.calcDigits("e")
                    this.high_precision = this.precision + 1
                }
            } else if (this.data.block.op_types.includes("iso_simple")) {
                if (this.instrument_data.instrument_class && this.has_hi_res) { //TODO CHIEDERE CONFERMA A ROBERTO
                    this.precision = this.calcDigits("e")
                    this.high_precision = this.calcDigits("d")
                } else {
                    this.precision = this.calcDigits("d")
                    this.high_precision = this.precision + 1
                }
            } else {
                this.precision = this.calcDigits("d")
                this.high_precision = "0" // high resolution is unused on ISO and LAT certificates
            }
        },
        calculateMinDiv(range) {
            if (range) {
                let types = this.data ? this.data.block.op_types : this.op_types
                if (this.measures.hi_res && this.measures.hi_res == "on") {
                    if (types.includes("leg")) {
                        return range.d
                    } else if (types.includes("iso_simple")) {
                        let min_div = this.instrument_data.instrument_class ? range.d : Big(range.d).div(10).toString()
                        return min_div
                    } else {
                        return range.d
                    }
                } else {
                    if (types.includes("leg")) {
                        return range.e
                    } else if (types.includes("iso_simple")) {
                        let min_div = this.instrument_data.instrument_class ? range.e : range.d
                        return min_div
                    } else {
                        return range.d
                    }
                }
            } else {
                return this.round("0")
            }
        },
        readingWarning(value, range = null) {
            let check = this.checkReading(value, range)
            let res = 'error_field'
            switch (check) {
                case 'done':
                    res = ''
                    break
                case 'failed':
                case 'uncomplete':
                    break
            }
            return res
        },
        differenceInt(reading, mass) {
            if (reading && mass && isFinite(reading) && isFinite(mass)) {
                let difference = Big(reading).minus(mass)
                return this.round(difference, this.high_precision)
            }
            return this.round(0)
        },
        calculateActualClass(){
            let max_range = this.findMaxRange()
            let divs = Big(max_range.div_nr)
            if(divs.gte(division_ranges["second_limit"])){
                return 1
            } else if(divs.gte(division_ranges["third_limit"])){
                return 2
            } else if(divs.gte(division_ranges["fourth_limit"])){
                return 3
            } else {
                return 4
            }
        },
        calculateMass(value, actualClass = this.instrument_data.instrument_class) {
            let corrected = Big(value).times(Big(10).pow(4 - actualClass))
            for (let range of this.instrument_data.ranges) {
                let minDiv = this.data.instrument_data.instrument_class ? range.e : range.d
                if (Big(range.div_nr).gte(corrected)) {
                    return corrected.times(minDiv).toString()
                }
            }
            return this.round("0")
        },
        getTolerances() {
            if (this.data.current_tolerance) {
                let tolerance = this.data.current_tolerance
                if (tolerance.t_type === "law") {
                    return tolerance
                } else {
                    for (let sub_tolerance of tolerance.t_vals) {
                        let name = this.data.block.name.replace("_before", "").replace("_cemento", "").replace("_additives", "").replace("_comparison", "").trim()
                        console.log("$$ tolerance name", name, sub_tolerance.test_type)
                        if (sub_tolerance.test_type === "unique" || sub_tolerance.test_type === name) {
                            return sub_tolerance
                        }
                    }
                }
            }
        },
        buildToleranceVal(tolerance, range) {
            if (tolerance) {
                if (tolerance.t_calc === "perc") {
                    let temp = Big(tolerance.t_val).div(100)
                        // let temp = tolerance.t_val / 100
                        // return this.round(range.max * temp)
                    return this.round(temp.times(range.max).toString())
                } else if (tolerance.t_calc === "val") {
                    // return this.round(tolerance.t_val * range.d)
                    return this.round(Big(tolerance.t_val).times(range.d))
                } else {
                    return -1
                }
            } else {
                return null
            }
        },
        buildTolerances() {
            console.log("$$ building tolerances")
            let tolerance = this.getTolerances()
            if (tolerance) {
                this.measures.useTolerance = true
                this.measures.toleranceData = tolerance
                this.measures.tolerance = this.getToleranceVal(tolerance)
            } else {
                this.measures.useTolerance = false
                this.measures.tolerance = "non presente"
            }
        },


        handleToleranceChange() {
            for (let item of this.measures.items) {
                item.toleranceError = this.handleToleranceError(item)
                item.tolerance = this.measures.tolerance
            }
        },
        getToleranceVal(tolerance) {
            console.log("$$ tolerance", tolerance)
            if (tolerance && tolerance.t_type && tolerance.t_type == "law") {
                return null
            } else if (tolerance && tolerance.t_calc) {
                return tolerance.t_val
            }
            return null
        },
        updateTolerance() {
            console.log("$$ update tolerance to be extended")
        },
        handleInvalidPrimaries() {
            if (this.data && this.data.primaries && this.data.invalidPrimaries) {
                console.log("$$ to be implemented")
            }
        },
        removeRow(index) {
            this.measures.items.splice(index, 1)
        },
        async findFormulas() {
            // console.log("$$ finding formulas", this.data.block)
            if (this.data && this.data.block.formulas) {
                for (let formulaID of this.data.block.formulas) {
                    let res = await this.$store.state.$pouch.find('masters', { selector: { _id: formulaID } })
                    if (res.docs.length > 0) {
                        this.formulas[formulaID] = res.docs[0]
                            // console.log("$$ formula added ", formulaID)
                    }
                }
                // console.log("$$ all formulas", this.formulas)
            }
        },
        calc_P(row, reading = null, addLoad = null, maxRange = null) {
            if (reading == null) {
                reading = row.reading
            }
            if (addLoad == null) {
                addLoad = row.addLoad
            }
            let min_div = 0
            let range = null
            if ( maxRange ){
                range = maxRange
            } else {
                range = this.calcMinRange(reading)
            }
            // let range = this.instrument_data.custom_data.multiext ? this.currMaxRange : this.calcMinRange(reading)
            min_div = this.calculateMinDiv(range)
            if (this.formulas && this.formulas['formula:formula_P']) {
                let formulaP = this.formulas['formula:formula_P']
                formulaP.data.I = reading
                formulaP.data.AL = addLoad
                if (this.instrument_data.family == "bilancia nawi meccanica"){
                    formulaP.data.e = 2*min_div
                } else {
                    formulaP.data.e = min_div
                }
                let resu = nerdamer(formulaP.equation, formulaP.data).evaluate().text()
                return this.round(resu, this.high_precision)
            } else {
                return this.round(0, this.high_precision)
            }
        },
        calculateResult(row, range = null) {
            let res = this.checkReading(row.reading, range)
            switch (res) {
                case 'uncomplete':
                    this.$set(row, 'result', 'uncomplete')
                    break
                case 'failed':
                    this.$set(row, 'result', 'failed')
                    break
                case 'done':
                    if (row.error_corr && Math.abs(row.error_corr) > 0) {
                        this.$set(row, 'result', Math.abs(row.error_corr) <= row.mpe ? 'done' : 'failed')
                    } else {
                        this.$set(row, 'result', Math.abs(row.error) <= row.mpe ? 'done' : 'failed')
                    }
                    break
            }
        },
        calcMeasures() {
            if (!this.conf.min_readings) {
                if (this.instrument_data.custom_data.support_points != undefined && this.instrument_data.custom_data.support_points != null) {
                    try {
                        console.log("******* INSTRUMENT SUPPORT POINT NUMBER", parseInt(this.instrument_data.custom_data.support_points))
                        return parseInt(this.instrument_data.custom_data.support_points)
                    } catch (error) {
                        return 0
                    }
                } else {
                    console.log("DEBUG: instrument data has no support points.")
                    return 0
                }
            } else {
                return this.conf.min_readings
            }
        },
        changeReading(row, range = null) {
            if (this.measures.hi_res == 'off' && row.addLoad != null & row.addLoad != '' && row.addLoad != 0 && row.reading) {
                row.p = this.calc_P(row, null, null, range)
            }
            if (row.reading == null || row.reading == '' || (this.measures.hi_res == "off" && (row.addLoad == null || row.addLoad == ''))) {
                row.result = 'uncomplete'
            } else {
                row.result = 'done'
            }
        },
        resetValues(items) {
            for (let item of items) {
                item.reading = undefined;
                item.addLoad = undefined;
                item.result = 'uncomplete';
                item.p = 0;
            }
        },
        changeAddLoad(row, range = null) {
            if (this.measures.hi_res == 'off' && row.reading != null & row.reading != '' && row.addLoad) {
                row.p = this.calc_P(row,null, null, range)
            }
            if (row.reading == null || row.reading == '' || row.addLoad == null ||row.addLoad == '') {
                row.result = 'uncomplete'
            } else {
                row.result = 'done'
            }
        },
        readingPlaceholder(mass) {
            return mass ? mass.toString() : ""
        },
        findPrimaryByFamily(families, primaries = this.data.primaries) {
            if (primaries) {
                for (var primary of primaries) {
                    // console.log("$$ primary found", primary)
                    if (families.includes(primary.family)) {
                        return primary
                    }
                }
            }
            return null
        },
        async buildWithCategory() {
            if (this.instrument_data) {
                if (this.instrument_data.category) {
                    let category = await this.$store.state.$pouch.get('masters', this.instrument_data.category).catch(err => {
                        console.log("$$ debug errore trovato", err)
                    })
                    if (category) {
                        // console.log("category: ", category)
                        let categoryblock = this.extractCategoryBlock(category)
                        // console.log("category: block ", categoryblock)
                        if (categoryblock.calc_value) {
                            return this.defaultCategoryBuilder()
                        }
                        return this.buildCategoryFromValues(categoryblock)
                    }
                } else {
                    return this.defaultCategoryBuilder()
                }
            }
            return null
        },
        extractCategoryBlock(category) {
            let block_id = this.data.block._id
            if (this.data.block.op_types.includes("leg")) {
                return category.leg[block_id]
            } else if (this.data.block.op_types.includes("iso")) {
                return category.iso[block_id]
            } else if (this.data.block.op_types.includes("iso_simple")) {
                return category.iso_simple[block_id]
            }
        },
        buildCategoryFromValues(catblock) {
            if (catblock.cat_type == "single") {
                return catblock.value ? catblock.value : this.round(0)
            } else {
                for (let trial of catblock.trials) {
                    if (trial.values_nr == this.conf.min_readings) {
                        return trial.values
                    }
                }
                return null
            }
        },
        defaultCategoryBuilder() {
            if (this.data.block.op_types.includes("leg") || this.data.block.op_types.includes("iso_simple")) {
                switch (this.instrument_data.family) {
                    case "bilancia nawi":
                        return this.defaultNawiBuilder()
                    case "bilancia nawi meccanica":
                        return this.defaultNawiBuilder()
                    case "bilancia awi X":
                        return this.defaultAwiBuilder()
                    case "bilancia awi Y":
                        return this.defaultAwiBuilder()
                }
            }
        },
        defaultNawiBuilder() {
            console.log("$$ debug block name", this.data.block.name)
            switch (this.data.block.name.trim()) {
                case "eccentricity":
                    return this.calcEccentricityDef()
                case "eccentricity_big":
                    return this.calcEccentricityBigDef()
                case "repeatability":
                    return this.calcRepeatabilityDef()
                case "linearity":
                    return this.calcLinearityDef2()
                case "mobility":
                    return this.calcMobilityDef()
                case "linearity_cemento":
                    return this.calcLinearityDef2()
                case "linearity_zavorra":
                    return this.calcLinearityDef2()
                case "linearity_additives":
                    return null
                case "linearity_comparison":
                    return null
                case "comparison":
                    return this.calcComparisonDef()
                default:
                    console.log("$$ debug block name not found", this.data.block.name)
                    return this.round(0)
            }
        },
        defaultAwiBuilder() {
            switch (this.data.block.name) {
                case "eccentricity":
                    return this.calcEccentricityDef()
                case "repeatability":
                    return this.calcRepeatabilityDef()
                case "linearity":
                    return this.calcLinearityDef2()
                case "pretest":
                    return this.calcPretestDef()
                case "tare":
                    return this.calcTareDef()
                case "linearity_dynamic":
                    return this.calcLinearityDynamicDef()
                case "eccentricity_dynamic":
                    return this.calcEccentricitDynamicDef()
                default:
                    return this.round(0)
            }
        },
        calcEccentricityDef() {
            console.log("category: eccentricity builder")
                // console.log("category: formulas", this.formulas)
            let fcd = this.formulas['formula:caricoDecentrato']
            fcd.data.M = this.findMaxRange().max
            fcd.data.p = this.calcMeasures()
            let resu = nerdamer(fcd.equation, fcd.data).evaluate().text()
                // console.log("category: cd result", resu)
            return this.round(resu)
        },
        calcEccentricityBigDef() {
            let fourty = Big(this.findMaxRange().max).times(0.4)
            return this.round(fourty)
        },
        calcRepeatabilityDef() {
            console.log("category: repeatability builder")
            let max = Big(this.findMaxRange().max)
            return this.round(max.times(repeatability_default).div(100))
        },
        calcLinearityDef2(){
            console.log("category: linearity builder new")
            let returnVals = []
            let previousMax = -1
            let actualClass = this.calculateActualClass()
            for (let i = 0; i< this.data.instrument_data.ranges.length; i++){
                let range = this.data.instrument_data.ranges[i]
                if(i == 0){
                    //TODO questo valore è schiantato qui!
                    let minDiv = this.calculateMinDiv(range)
                    let firstVal = Big(minDiv).times(10)
                    returnVals.push(this.round(firstVal))
                }
                if(Big(range.min).gt(previousMax)){
                    returnVals.push(this.round(range.min))
                    previousMax = range.min
                }
                for(let k = 0; k < linearity_values.length; k++){
                    let temp = this.calculateMass(linearity_values[k], actualClass)
                    if(Big(temp).lte(0)){
                        returnVals.push(temp)
                    } else if (Big(temp).gt(previousMax)){
                        returnVals.push(temp)
                        previousMax = temp
                    }
                }
                if(i < this.data.instrument_data.ranges.length - 1){
                    let temp = Big(range.max).minus(Big(range.max).times(0.1))
                    if(temp.gt(previousMax)){
                        returnVals.push(this.round(temp))
                        previousMax = range.max
                    }
                }
            }
            returnVals.push(this.round(Big(this.findMaxRange().max)))
            return returnVals
        },
        calcLinearityDef3(){
            console.log("category builder: linearity 3")
            console.log("category: linearity builder new")
            let returnVals = []
            let actualClass = this.calculateActualClass()
            if (this.data.instrument_data.ranges.length > 1){
                let previousMax = -1
                for(let i = 0; i< this.data.instrument_data.ranges.length; i++){
                    let range = this.data.instrument_data.ranges[i]
                    if (Big(range.min).gt(previousMax)){
                        returnVals.push(this.round(range.min))
                        previousMax = range.min
                    }
                    for(let k = 0; k < linearity_values_multirange.length; k++){
                        let temp = this.calculateMass(linearity_values_multirange[k], actualClass)
                        if(Big(temp).lte(0)){
                            returnVals.push(temp)
                        } else if (Big(temp).gt(previousMax)){
                            returnVals.push(temp)
                            previousMax = temp
                        }
                    }
                    if(i < this.data.instrument_data.ranges.length - 1){
                        let temp = Big(range.max).minus(Big(range.max).times(0.1))
                        if(temp.gt(previousMax)){
                            returnVals.push(this.round(temp))
                            previousMax = range.max
                        }
                    }
                }
                returnVals.push(this.round(Big(this.findMaxRange().max)))
            } else {
                let range = this.data.instrument_data.ranges[0]
                returnVals.push(this.round(range.min))
                for(let i = 0; i < linearity_values.length; i++){
                    let temp = this.calculateMass(linearity_values[i], actualClass)
                    returnVals.push(temp)
                }
                returnVals.push(this.round(Big(this.findMaxRange().max)))
            }
            return returnVals
        },
        calcLinearityDynamicDef() {
            let values = []
            let previousMax = -1
            let class_factor = Math.pow(10, (4 - this.data.instrument_data.instrument_class))
            for (let range of this.data.instrument_data.ranges) {
                let minDiv = this.calculateMinDiv(range)
                if (range.min > previousMax) {
                    values.push(this.round(range.min))
                    previousMax = range.min
                }
                let second = Big(minDiv).times(linearity_values[0]).times(class_factor)
                if (second.gt(previousMax) && second.lte(range.max)) {
                    values.push(this.round(second))
                    previousMax = second.toString()
                }
                let third = Big(minDiv).times(linearity_values.slice(-1).pop()).times(class_factor)
                if (third.gt(previousMax) && third.lte(range.max)) {
                    values.push(this.round(third))
                    previousMax = third.toString()
                }
                let temp = Big(range.max).minus(Big(range.max).times(0.1))
                if(temp.gt(previousMax)){
                    values.push(this.round(temp))
                    previousMax = temp
                }
            }
            return values
        },
        calcEccentricitDynamicDef() {
            let values = []
            let maxRange = this.findMaxRange()
            let third = Big(maxRange.max).times(0.3)
            values.push(this.round(third))
            values.push(this.round(third))
            return values

        },
        calcTareDef() {
            console.log("$$ building with tare def")
            let values = []
            let twenty = Big(this.data.instrument_data.custom_data.sub_tare).times(0.2)
            let fifty = Big(this.data.instrument_data.custom_data.sub_tare).times(0.5)
            let maxRange = this.findMaxRange()
            let minRange = this.data.instrument_data.ranges[0]
            let convTwenty = Big(minRange.min).add(twenty)
            let netTwenty = Big(maxRange.max).sub(twenty)
            let convFifty = Big(minRange.min).add(fifty)
            let netFifty = Big(maxRange.max).sub(fifty)
            let min20 = {
                nom: convTwenty.toString(),
                conv: convTwenty.toString(),
                tare: twenty.toString(),
                netVal: minRange.min
            }
            values.push(min20)
            let max20 = {
                nom: maxRange.max,
                conv: maxRange.max,
                tare: twenty.toString(),
                netVal: netTwenty.toString()
            }
            values.push(max20)
            let min50 = {
                nom: convFifty.toString(),
                conv: convFifty.toString(),
                tare: fifty.toString(),
                netVal: minRange.min
            }
            values.push(min50)
            let max50 = {
                nom: maxRange.max,
                conv: maxRange.max,
                tare: fifty.toString(),
                netVal: netFifty.toString()
            }
            values.push(max50)
            return values
        },
        calcPretestDef() {
            let values = []
            let maxRange = this.findMaxRange()
            let minRange = this.data.instrument_data.ranges[0]
            values.push(minRange.min)
            values.push(maxRange.max)
            return values
        },
        calcComparisonDef(){
            let values = []
            let maxRange = this.findMaxRange()
            let max = Big(maxRange.max)
            values.push(this.round(max.times(comparison_values['first_perc'])))
            values.push(this.round(max.times(comparison_values['second_perc'])))
            values.push(this.round(max.times(comparison_values['last_perc'])))
            return values
        },
        calcFirstLinVal() {
            let range = this.instrument_data.ranges[0]
            // let firstVal = range.e > 0 ? Big(range.e) : Big(range.d) # OLD FORMULA, DEPRECATED IN THE NEXT RELEASE
            return this.round(range.min)
        },
        calcLinMax() {
            // deprecated, not requested anymore
            let maxR = this.findMaxRange()
            let temp = Big(maxR.max)
            if (this.instrument_data.uom === "g") {
                temp = temp.times(0.001)
            } else if (this.instrument_data.uom === "mg") {
                temp = temp.times(0.001).times(0.001)
            }
            let currMax = temp.gte(1000) ? Big(maxR.max).times(0.8).toString() : Big(maxR.max).toString()
            return currMax
        },
        buildConversionFactor() {
            console.log("$$ stub for conversion factor ISO")
        },
        changeLinearityReading(row, direction){
            console.log("$$ change triggered")
            if(direction == "up" && row.index == this.measures.items_up.length -1 && this.onlyPrimaries){
                this.changeReading(row)
                let row_down = this.findRow(this.measures.items_down, row.index)
                row_down.reading = row.reading
                this.changeReading(row_down)
            } else {
                this.changeReading(row)
            }
        },
        changeLinearityAddLoad(row, direction){
            if(direction == "up" && row.index == this.measures.items_up.length - 1){
                this.changeAddLoad(row)
                let row_down = this.findRow(this.measures.items_down, row.index)
                row_down.addLoad = row.addLoad
                this.changeAddLoad(row_down)
            } else {
                this.changeAddLoad(row)
            }
        },
        async getImageID(){
            if(this.data.instrument_data.custom_data){
                let selector = {}
                if(this.data.block.name == "eccentricity_big"){
                    selector = {
                        doc_type: "imagepoint",
                        _id: "imagepoint:pesa_ponte"
                    }
                } else {
                    let points = this.data.block.conf.min_readings ? this.data.block.conf.min_readings : this.measures.points
                    let shape = this.data.instrument_data.custom_data.shape
                    selector = {
                        doc_type: "imagepoint",
                        points: points + ""
                    }
                    if (shape) {
                        selector['shape'] = shape
                    }
                }
                let search = await this.$store.state.$pouch.find("masters", {selector: selector})
                if (search && search.docs.length > 0){
                    this.measures.image_id = search.docs[0]._id
                }
            }
        },
        async getImage() {
            if (this.measures && this.measures.image_id) {
                let res = await this.$store.state.$pouch.get("masters", this.measures.image_id, { attachments: true })
                if (res) {
                    let arr = Object.keys(res._attachments)
                    this.image_data = "data:"
                    this.image_data += res._attachments[arr[0]].content_type
                    this.image_data += ";base64,"
                    this.image_data += res._attachments[arr[0]].data
                }
            }
        },
        changeRows(weightTotal){
            if(this.measures.weightTotal != weightTotal){
                this.measures.weightTotal = _.cloneDeep(weightTotal)
                let arr = this.findValues(weightTotal)
                arr[0] = this.calcFirstLinVal()
                this.measures.items_up.splice(0, this.measures.items_up.length)
                this.measures.items_down.splice(0, this.measures.items_down.length)
                for(let i = 0; i< arr.length; i++){
                    let mpe_curr = this.calc_MPE(this.calcMinRange(arr[i]), arr[i])
                    let item = linearity_item_new({
                        index: i,
                        mass: arr[i],
                        mpe: mpe_curr
                    })
                    this.measures.items_up.push(item)
                }
            } else {
                console.log("$$ same weight total, skipping")
            }
        },
        findComparisonPrecision(){
            if(this.data.primaries){
                let primary = this.findPrimaryByFamily(['bilancia nawi'], this.data.primaries)
                if(primary != null && primary.platforms.length > 0){
                    return primary.platforms[0].digits
                } 
            }
            return this.precision
        },
        calcTotal(row){
            //copied from cemento layout
            //used in GSP 1.15 linearity_zavorra trials
            if(row.sample_masses!=undefined && row.sample_masses!="" && row.zavorra!=undefined && row.zavorra!==""){
                row.isMultiple = this.checkMultiple(row)
                row.total = this.round(Big(row.sample_masses).plus(row.zavorra))
            }
        },
        checkMultiple(row){
            let calc = Big(row.zavorra).mod(row.sample_masses).eq(0)
            return calc
        },
        getCommonData(){
            //moved from linearity layout VP
            //1.15 GSP used in all linearity zavorra trials
            if(this.data.common_data.zavorra){
                for(let key in this.data.common_data.zavorra){
                    return this.data.common_data.zavorra[key].value
                }
            }
            return null
        },
        buildRows(weightTotal){
            //derived from changeRows of baseLayout mixin
            //1.15 GSP, used to build items from the "test zavorra" value
            if(this.measures.weightTotal != weightTotal){
                this.measures.weightTotal = _.cloneDeep(weightTotal)
                let arr = this.findValues(weightTotal)
                arr[0] = this.calcFirstLinVal()
                this.measures.items.splice(0, this.measures.items.length)
                for(let i = 0; i< arr.length; i++){
                    let mpe_curr = this.calc_MPE(this.calcMinRange(arr[i]), arr[i])
                    let sample_masses = Big(weightTotal).gte(arr[i]) ? arr[i] : weightTotal
                    let zavorra = Big(weightTotal).gte(arr[i]) ? 0 : arr[i] - weightTotal
                    let item = linearity_zavorra_item({
                        index: i,
                        mass: arr[i],
                        sample_masses: sample_masses,
                        zavorra: zavorra,
                        total: arr[i],
                        mpe: mpe_curr

                    })
                    this.measures.items.push(item)
                }
            } else {
                console.log("$$ same weight total, skipping")
            }
        },
        changeResolution(resolution){
            //1.15 GSP: to change the resolution from the parent
            this.measures.hi_res = resolution
        },
        setMeasures(measures){
            //1.15 GSP: temporary solution to fix life cycle problem
            this.measures = measures
        },
        updateItemColor(zavorra, result){
            console.log("$$ measures", this.measures.items)
            for(let item of this.measures.items){
                if(item.zavorra == zavorra){
                    item.button_class = this.checkColor(result)
                }
            }
        },
        checkColor(result){
            console.log("$$ checking color", result)
            let addition = ""
            let base = "full-width mt-1"
            if(result){
                if(result == "done"){
                    addition = " success"
                } else if (result == "failed") {
                    addition = " error"
                }
            }
            return base + addition
        },
        getRepResult(){
            if(this.measures.repPoints){
                let result = 'done'
                for(let singleRep of Object.values(this.measures.repPoints)){
                    switch(singleRep.block.measures.result){
                        case 'uncomplete':
                            result = 'uncomplete'
                            break
                        case 'failed':
                            if(result == "uncomplete"){
                                break
                            } else {
                                result = 'failed';
                                break
                            }
                        case 'done':
                            break
                    }
                }
                return result
            }
            return ""
        },

        readingAddFunc(row, fieldname, currRange){
            let range = currRange
            if (range == null) {
                range = this.calcMinRange(row.mass)
            }
            let div = this.calculateMinDiv(range)
            let temp = this.round(Big(row[fieldname]).plus(div))
            if(Big(temp).gte(0))
            {
                row[fieldname] = temp
                if (this.measures.items_up && row.index == this.measures.items_up.length - 1){
                    this.changeLinearityReading(row, 'up')
                } else {
                    this.changeReading(row, currRange)
                }
            }
        },
        loadAddFunc(row, fieldname, currRange){
            let range = currRange
            if (range == null) {
                range = this.calcMinRange(row.mass)
            }
            let div = null
            if (range.e){
                div = Big(range.e).times(0.1).toString()
            } else {
                div = Big(range.d).times(0.1).toString()
            }
            let temp = this.round(Big(row[fieldname]).plus(div), this.high_precision)
            if (Big(temp).gte(0))
            {
                row[fieldname] = temp
                if (this.measures.items_up && row.index == this.measures.items_up.length - 1){
                    this.changeLinearityAddLoad(row, 'up')
                } else {
                    this.changeAddLoad(row, currRange)
                }
            }
        },
        readingSubFunc(row, fieldname, currRange){
            let range = currRange
            if (range == null) {
                range = this.calcMinRange(row.mass)
            }
            let div = this.calculateMinDiv(range)
            let temp = this.round(Big(row[fieldname]).minus(div))
            if(Big(temp).gte(0))
            {
                row[fieldname] = temp
                if (this.measures.items_up && row.index == this.measures.items_up.length - 1){
                    this.changeLinearityReading(row, 'up')
                } else {
                    this.changeReading(row, currRange)
                }
            }
        },
        loadSubFunc(row, fieldname, currRange){
            let range = currRange
            if (range == null) {
                range = this.calcMinRange(row.mass)
            }
            let div = null
            if (range.e){
                div = Big(range.e).times(0.1).toString()
            } else {
                div = Big(range.d).times(0.1).toString()
            }
            let temp = this.round(Big(row[fieldname]).minus(div), this.high_precision)
            if(Big(temp).gte(0))
            {
                row[fieldname] = temp
                if (this.measures.items_up && row.index == this.measures.items_up.length - 1){
                    this.changeLinearityAddLoad(row, 'up')
                } else {
                    this.changeAddLoad(row, currRange)
                }
            }
        },
        calculateMaxRange(){
            console.log("$$ default stub func")
        }
    },
    computed: {
        checkStatic() {
            if (this.data.m_static != undefined && this.data.m_static != null) {
                return !this.data.m_static
            } else {
                return true
            }
        },
        precision_overflow() {
            for (let elm of this.measures.items) {
                let res = this.checkReading(elm.reading)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            return false
        },
        has_hi_res() {
            if (this.instrument_data && this.instrument_data.instrument_class) {
                for (let range of this.instrument_data.ranges) {
                    if (Big(range.d).times(5).gte(range.e)) {
                        return false
                    }
                }
            }
            return true
        },
        can_change_masses(){
            //for GSP 1.15 zavorra blocks
            if(this.measures && this.measures.change_masses){
                if(this.measures.change_masses == "on"){
                    return true
                } else {
                    return false
                }
            }
            return false
        },
        calculateTotal() {
            let sum = Big(0)
            if (this.data.primaries) {
                for (let single of this.data.primaries) {
                    if (single.family === "pesiera") {
                        let convFactor = uoms_conversion[single.primary_data.data.uom][this.instrument_data.uom]
                        sum = Big(single.primary_data.data.weightTotal).times(convFactor).plus(sum)
                    }
                }
            }
            return sum.toString()
        },
        onlyPrimaries() {
            if (this.data.primaries) {
                let found = checkWeight(this.data.primaries)
                if (found) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        },
        currentPrecision() {
            if (this.measures && this.measures.hi_res == "on") {
                return this.high_precision
            } else {
                return this.precision
            }
        },
        computeToleranceType() {
            let dict = {
                type: "",
                value: "",
                uom: ""
            }
            if (this.data.current_tolerance) {
                let tol = this.data.current_tolerance
                dict.type = _.keyBy(tolerance._type, "id")[tol.t_type].text
                if (tol.t_type == "law") {
                    dict.uom = this.instrument_data.uom
                    dict.value = ""
                } else {
                    if (this.measures.toleranceData) {
                        if (this.measures.toleranceData.test_type == "unique") {
                            dict.value = tolerance._values[0].text
                        } else {
                            dict.value = tolerance._values[1].text
                        }
                        dict.uom = _.keyBy(tolerance._calc, "id")[this.measures.toleranceData.t_calc].text
                    }
                }
            }
            return dict
        },
        notMultiple(){
            //GSP 1.15 zavorra blocks: if the computed is true, an error will be displayed in the layout
            for(let item of this.measures.items){
                if(!item.isMultiple){
                    return true
                }
            }
            return false
        }
    },
    watch: {
        "instrument_data.custom_data.multiext":{
            handler(){
                if(this.instrument_data.custom_data.multiext){
                    this.calculateMaxRange()
                }
            }
        }
    },
    async beforeMount() {
        console.log("$$ before mount from layout mixin", this.data.block.name)
        this.buildConversionFactor()
        await this.findFormulas()
        await this.beforeMountBuilder()
        if (!this.preview) {
            this.updateTolerance()
        }
        this.handleInvalidPrimaries()

    }

}